export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left - Text */}
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium mb-4">
              O que é CSSBuy Spreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Sua Ferramenta Essencial para
              <br />
              <span className="text-accent-500">Compras da China</span>
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-5">
              CSSBuy Spreadsheet é uma ferramenta indispensável para compradores internacionais que desejam adquirir produtos da China de forma inteligente. Nossa planilha organiza milhares de produtos verificados por categorias, com preços sempre atualizados e links diretos, eliminando a necessidade de navegar em sites chineses complexos.
            </p>
            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              Com mais de 15 categorias e centenas de produtos selecionados manualmente, você encontra desde tênis e roupas até acessórios e perfumes — tudo organizado para facilitar sua experiência de compra internacional.
            </p>

            {/* Stats */}
            <div className="flex items-center gap-10">
              <div>
                <p className="font-heading text-4xl font-bold text-foreground-950">15+</p>
                <p className="text-foreground-500 text-sm mt-1">Categorias</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div>
                <p className="font-heading text-4xl font-bold text-foreground-950">1000+</p>
                <p className="text-foreground-500 text-sm mt-1">Produtos</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div>
                <p className="font-heading text-4xl font-bold text-foreground-950">2026</p>
                <p className="text-foreground-500 text-sm mt-1">Atualizado</p>
              </div>
            </div>
          </div>

          {/* Right - Images with text labels */}
          <div className="flex-1 relative">
            <div className="relative h-[420px]">
              {/* Small image - top left */}
              <div className="absolute top-0 left-0 w-[55%] h-[55%] rounded-xl overflow-hidden z-20 group">
                <img
                  src="https://readdy.ai/api/search-image?query=Designer%20sneaker%20displayed%20on%20warm%20sand%20colored%20marble%20pedestal%2C%20elevated%20product%20photography%2C%20luxury%20fashion%20editorial%2C%20dramatic%20side%20lighting%20casting%20artistic%20shadows%2C%20premium%20texture%20detail%2C%20no%20text&width=500&height=500&seq=about-shoe-v3&orientation=squarish"
                  alt="CSSBuy Spreadsheet - Tênis"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <p className="text-background-50 font-heading text-lg font-semibold">Tênis</p>
                  <p className="text-background-50/70 text-xs">+200 modelos</p>
                </div>
              </div>
              {/* Large image - bottom right */}
              <div className="absolute bottom-0 right-0 w-[65%] h-[70%] rounded-xl overflow-hidden z-10 group">
                <img
                  src="https://readdy.ai/api/search-image?query=Fashion%20clothing%20and%20accessories%20artistic%20flat%20lay%20on%20warm%20oatmeal%20colored%20linen%2C%20editorial%20styling%20with%20folded%20garments%20and%20delicate%20jewelry%2C%20soft%20morning%20light%20through%20sheer%20curtain%2C%20elegant%20composition%2C%20no%20text&width=600&height=700&seq=about-fashion-v3&orientation=portrait"
                  alt="CSSBuy Spreadsheet - Moda e Acessórios"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-4">
                  <p className="text-background-50 font-heading text-lg font-semibold">Moda & Acessórios</p>
                  <p className="text-background-50/70 text-xs">+800 produtos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}